import { toast } from 'react-toastify';
import s from '../allservices.jsx';
import { getClientId, getClientSecret,buildClientHeader } from "../../utils/clientAuth.js";
import uuidv4 from 'uuid/v4';
const getPasswordService = (actionCallback,userid) => {
    // const cardNumber = localStorage.getItem("cardNumber")
    let plink =  localStorage.getItem('pform')==='AU'? process.env.REACT_APP_SERVICEURL_AU : process.env.REACT_APP_SERVICEURL_NZ 
    let gid = getClientId();
    let traceId = getClientId();
    let appids = localStorage.getItem('pform') === 'AU' ? 'klickexau' : 'klickex'
    fetch(plink + s.get_password + "/" + userid + "/" + appids , {
        headers: new Headers({
            'Content-Type': 'application/json',
            'clientId': gid,
            'clientSecret': getClientSecret(gid, userid), 
             'X-Trace-Id': traceId,
             'X-Client-APP':buildClientHeader(),
        })
    })
        .then(res => {
            if (res.status === 200 || res.status === 201 || res.status === 204 || res.status === 304) {
                res.json().then(json => actionCallback(json, "success"))
                toast.success(res.headers.get('message'), {
                    position: "top-right",
                    draggablePercent: 60,
                    autoClose: 2000,
                    newestOnTop: true,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: false
                });
            } 
         
            // else {
            //     // 
            //     actionCallback(res.headers.get('message'),"error")
            //     toast.error(res.headers.get('message'), {
            //         position: "top-right",
            //         draggablePercent: 60,
            //         autoClose: 2000,
            //         newestOnTop: true,
            //         hideProgressBar: false,
            //         closeOnClick: true,
            //         pauseOnHover: true,
            //         draggable: false
            //     }); 
            // }

//    else {

//     const errorMessage = res.headers.get('message');

//     actionCallback({
//         status: res.status,
//         message: errorMessage
//     }, "error");

//   if (
//     res.status !== 428 ||
//     (
//         errorMessage &&
//         errorMessage.indexOf("Your security Q&A must be reset") === -1
//     )
// ) {

//     toast.error(errorMessage, {
//         position: "top-right",
//         draggablePercent: 60,
//         autoClose: 2000,
//         newestOnTop: true,
//         hideProgressBar: false,
//         closeOnClick: true,
//         pauseOnHover: true,
//         draggable: false
//     });

// }
// }
else {

    const errorMessage = res.headers.get('message');

    actionCallback({
        status: res.status,
        message: errorMessage
    }, "error");

    if (res.status !== 428) {

        toast.error(errorMessage, {
            position: "top-right",
            draggablePercent: 60,
            autoClose: 2000,
            newestOnTop: true,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: false
        });

    }
}
        })
}

export default getPasswordService;


// WEBPACK FOOTER //
// ./src/services/components/get_password.jsx